module.exports = __webpack_public_path__ + "static/media/hiv_in_jackson.551104ba.jpg";